import { render } from "./LearningGoalComponent.vue?vue&type=template&id=604e4206&scoped=true"
import script from "./LearningGoalComponent.vue?vue&type=script&lang=js"
export * from "./LearningGoalComponent.vue?vue&type=script&lang=js"

import "./LearningGoalComponent.vue?vue&type=style&index=0&id=604e4206&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604e4206"]])

export default __exports__